"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureFlagManager = exports.FeatureFlagManager = exports.FeatureFlags = exports.FeatureFlagName = void 0;
exports.isFeatureFlagEnabled = isFeatureFlagEnabled;
// Determine whether feature flag is enabled based on environment variable setting
function isFeatureFlagEnabled(featureFlagName, defaultValue = false) {
    const flag = process.env[featureFlagName];
    if (flag === undefined) {
        return defaultValue; // allows consumer to set a default value when environment variable not set
    }
    else {
        return flag === "1" || flag.toLowerCase() === "true"; // can enable feature flag by set environment variable value to "1" or "true"
    }
}
class FeatureFlagName {
    static CLIDotNet = "TEAMSFX_CLI_DOTNET";
    static SampleConfigBranch = "TEAMSFX_SAMPLE_CONFIG_BRANCH";
    static ChatParticipantUIEntries = "TEAMSFX_CHAT_PARTICIPANT_ENTRIES";
    static HideGitHubCopilotPreviewTag = "TEAMSFX_HIDE_GITHUB_COPILOT_PREVIEW_TAG";
    static SMEOAuth = "SME_OAUTH";
    static ShowDiagnostics = "TEAMSFX_SHOW_DIAGNOSTICS";
    static TelemetryTest = "TEAMSFX_TELEMETRY_TEST";
    static DevTunnelTest = "TEAMSFX_DEV_TUNNEL_TEST";
    static SyncManifest = "TEAMSFX_SYNC_MANIFEST";
    static KiotaNPMIntegration = "TEAMSFX_KIOTA_NPM_INTEGRATION";
    static CEAEnabled = "TEAMSFX_CEA_ENABLED";
    static SandBoxedTeam = "TEAMSFX_SANDBOXED_TEAM";
    static SensitivityLabelEnabled = "TEAMSFX_SENSITIVITY_LABEL";
    static DAMetaOS = "TEAMSFX_DA_METAOS";
    static CFShortcutMetaOS = "TEAMSFX_CF_SHORTCUT_METAOS";
    static MCPForDA = "TEAMSFX_MCP_FOR_DA";
    static BrokerAuth = "TEAMSFX_BROKER_AUTH";
    // Add config files to existing project to make it toolkit compatible
    static GenerateConfigFiles = "TEAMSFX_GENERATE_CONFIG_FILES";
    // Permanent feature flag for sovereign cloud environment setting
    static SovereignCloudEnvironment = "TEAMSFX_SOVEREIGN_CLOUD_ENVIRONMENT";
}
exports.FeatureFlagName = FeatureFlagName;
class FeatureFlags {
    // Testing feature flags - not for production use
    static CLIDotNet = { name: FeatureFlagName.CLIDotNet, defaultValue: "false" };
    static ChatParticipantUIEntries = {
        name: FeatureFlagName.ChatParticipantUIEntries,
        defaultValue: "false",
    };
    static HideGitHubCopilotPreviewTag = {
        name: FeatureFlagName.HideGitHubCopilotPreviewTag,
        defaultValue: "false",
    };
    static SMEOAuth = { name: FeatureFlagName.SMEOAuth, defaultValue: "false" };
    static ShowDiagnostics = {
        name: FeatureFlagName.ShowDiagnostics,
        defaultValue: "false",
    };
    static TelemetryTest = {
        name: FeatureFlagName.TelemetryTest,
        defaultValue: "false",
    };
    static DevTunnelTest = {
        name: FeatureFlagName.DevTunnelTest,
        defaultValue: "false",
    };
    static SyncManifest = {
        name: FeatureFlagName.SyncManifest,
        defaultValue: "false",
    };
    static KiotaNPMIntegration = {
        name: FeatureFlagName.KiotaNPMIntegration,
        defaultValue: "true",
    };
    static CEAEnabled = {
        name: FeatureFlagName.CEAEnabled,
        defaultValue: "false",
    };
    static SandBoxedTeam = {
        name: FeatureFlagName.SandBoxedTeam,
        defaultValue: "false",
    };
    static SensitivityLabelEnabled = {
        name: FeatureFlagName.SensitivityLabelEnabled,
        defaultValue: "false",
    };
    static DAMetaOS = {
        name: FeatureFlagName.DAMetaOS,
        defaultValue: "false",
    };
    static CFShortcutMetaOS = {
        name: FeatureFlagName.CFShortcutMetaOS,
        defaultValue: "false",
    };
    static MCPForDA = {
        name: FeatureFlagName.MCPForDA,
        defaultValue: "true",
    };
    static BrokerAuth = {
        name: FeatureFlagName.BrokerAuth,
        defaultValue: "false",
    };
    static GenerateConfigFiles = {
        name: FeatureFlagName.GenerateConfigFiles,
        defaultValue: "false",
    };
    static SovereignCloudEnvironment = {
        name: FeatureFlagName.SovereignCloudEnvironment,
        defaultValue: "",
    };
}
exports.FeatureFlags = FeatureFlags;
class FeatureFlagManager {
    getBooleanValue(featureFlag) {
        return isFeatureFlagEnabled(featureFlag.name, featureFlag.defaultValue === "true" || featureFlag.defaultValue === "1");
    }
    setBooleanValue(featureFlag, value) {
        process.env[featureFlag.name] = value ? "true" : "false";
    }
    getStringValue(featureFlag) {
        return process.env[featureFlag.name] || featureFlag.defaultValue;
    }
    list() {
        return Object.values(FeatureFlags);
    }
    listEnabled() {
        return this.list()
            .filter((f) => isFeatureFlagEnabled(f.name))
            .map((f) => f.name);
    }
}
exports.FeatureFlagManager = FeatureFlagManager;
exports.featureFlagManager = new FeatureFlagManager();
//# sourceMappingURL=featureFlags.js.map